// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as N_RnrRepoManager from "../repo/N_RnrRepoManager.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as Languages$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";

function fetchRnrConfigApiCall(uuid, auth_token, dispatch) {
  var RepoInstance = N_RnrRepoManager.getRnrRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchRnRConfig, uuid, auth_token);
              }), (function (data) {
                console.log([
                      "fetchRnrConfigApiCall data",
                      data.vehicle_category
                    ]);
                return Curry._1(dispatch, {
                            TAG: /* SetConfig */6,
                            _0: {
                              TAG: /* Live */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetConfig */6,
                            _0: {
                              TAG: /* Error */2,
                              _0: error
                            }
                          });
              }));
}

function fetchRnrReportApiCall(uuid, auth_token, lang, dispatch) {
  var RepoInstance = N_RnrRepoManager.getRnrRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchRnrReport, uuid, auth_token, Languages$Catalyst.toLanguageString(lang));
              }), (function (report) {
                return Curry._1(dispatch, {
                            TAG: /* SetReport */0,
                            _0: {
                              TAG: /* Live */1,
                              _0: report
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetReport */0,
                            _0: {
                              TAG: /* Error */2,
                              _0: error
                            }
                          });
              }));
}

function fetchRnRHomepageVernacularContentApiCall(language, dispatch, on_success_callback) {
  Curry._1(dispatch, {
        TAG: /* SetVernacularContent */7,
        _0: {
          TAG: /* Loading */0,
          _0: undefined
        }
      });
  var RepoInstance = N_RnrRepoManager.getRnrRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchRnRHomepageVernacularContent, language);
              }), (function (data) {
                Curry._1(dispatch, {
                      TAG: /* SetVernacularContent */7,
                      _0: {
                        TAG: /* Live */1,
                        _0: data
                      }
                    });
                return Curry._1(on_success_callback, undefined);
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetVernacularContent */7,
                            _0: {
                              TAG: /* Error */2,
                              _0: error
                            }
                          });
              }));
}

function fetchRnRClaimRewardVernacularContentApiCall(language, on_success_callback, on_failure_callback) {
  var RepoInstance = N_RnrRepoManager.getRnrRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchRnRClaimRewardVernacularContent, language);
              }), Curry.__1(on_success_callback), Curry.__1(on_failure_callback));
}

function fetchRnRLoginDetailsVernacularContentApiCall(language, on_success_callback, on_failure_callback) {
  var RepoInstance = N_RnrRepoManager.getRnrRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchRnRLoginDetailsVernacularContent, language);
              }), Curry.__1(on_success_callback), Curry.__1(on_failure_callback));
}

function fetchRnRVideosDetailsVernacularContentApiCall(language, on_success_callback, on_failure_callback) {
  var RepoInstance = N_RnrRepoManager.getRnrRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchRnRVideoDetailsVernacularContent, language);
              }), Curry.__1(on_success_callback), Curry.__1(on_failure_callback));
}

export {
  fetchRnrConfigApiCall ,
  fetchRnrReportApiCall ,
  fetchRnRHomepageVernacularContentApiCall ,
  fetchRnRClaimRewardVernacularContentApiCall ,
  fetchRnRLoginDetailsVernacularContentApiCall ,
  fetchRnRVideosDetailsVernacularContentApiCall ,
  
}
/* N_RnrRepoManager Not a pure module */
